var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.role
    ? _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h6", [_vm._v(_vm._s(_vm.role.name))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                !_vm.role.id
                  ? _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Alias роли"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|alpha:en-US|min:4|max:255",
                                  expression:
                                    "'required|alpha:en-US|min:4|max:255'",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.role.name,
                                  expression: "role.name",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                name: "role_name",
                                "data-vv-as": "Alias роли",
                                placeholder: "Alias роли",
                              },
                              domProps: { value: _vm.role.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.role,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.errors.has("role_name")
                              ? _c(
                                  "small",
                                  { staticClass: "form-text text-danger" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.errors.first("role_name")) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Наименование роли (русский)"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:4|max:255",
                                  expression: "'required|min:4|max:255'",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.role.name_title,
                                  expression: "role.name_title",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                name: "role_name_title",
                                "data-vv-as": "Наименование роли (русский)",
                                placeholder: "Наименование роли",
                              },
                              domProps: { value: _vm.role.name_title },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.role,
                                    "name_title",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.errors.has("role_name_title")
                              ? _c(
                                  "small",
                                  { staticClass: "form-text text-danger" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.errors.first("role_name_title")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.role.id
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Новый доступ"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  regex: /^[0-9A-Za-z\/]+$/,
                                  min: 3,
                                  max: 255,
                                },
                                expression:
                                  "{required:true,regex:/^[0-9A-Za-z\\/]+$/,min:3,max:255}",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.permission.name,
                                expression: "permission.name",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "permit_name",
                              "data-vv-as": "Alias доступа",
                              placeholder: "Alias доступа",
                            },
                            domProps: { value: _vm.permission.name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.permission,
                                  "name",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("permit_name")
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.errors.first("permit_name")) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success m-t-10",
                              on: {
                                click: function ($event) {
                                  return _vm.updateRole("permit")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "Добавить\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm table-striped" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.permissions, function (record, index) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                index +
                                  1 +
                                  (_vm.paginator.current_page - 1) *
                                    _vm.paginator.per_page
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.created_at))]),
                          _vm._v(" "),
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected_permissions[record.id],
                                  expression: "selected_permissions[record.id]",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.selected_permissions[record.id]
                                )
                                  ? _vm._i(
                                      _vm.selected_permissions[record.id],
                                      null
                                    ) > -1
                                  : _vm.selected_permissions[record.id],
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selected_permissions[record.id],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selected_permissions,
                                          record.id,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selected_permissions,
                                          record.id,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.selected_permissions,
                                      record.id,
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-success f-l",
                          "data-style": "zoom-in",
                          loading: _vm.btn_role_update_loading,
                        },
                        on: { click: _vm.updateRole },
                      },
                      [_vm._v("Сохранить\n                        ")]
                    ),
                    _vm._v(" "),
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 3,
                            "margin-pages": 2,
                            "click-handler": _vm.getPermitions,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доступ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата создания")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }